module.exports = __webpack_public_path__ + "components/flag/static/square/al-8687c2216096c98372b22ddb9299e3b5.svg";